import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';

type Props = {
  offset: number;
  limit: number;
  total: number;
  onChange: (offset: number) => void;
  testid?: string;
};

export const Paginator = ({ offset, limit, total, onChange, testid }: Props) => {
  const { t } = useTranslation('simulation_page');
  if (total <= limit) return null;

  const page = Math.floor(offset / limit) + 1;
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const atStart = offset <= 0;
  const atEnd = offset + limit >= total;

  return (
    <div
      data-testid={testid ?? 'paginator'}
      className="flex items-center justify-between py-2 text-sm text-muted-foreground"
    >
      <span>
        {t('paginator_range', {
          start: offset + 1,
          end: Math.min(total, offset + limit),
          total,
        })}
      </span>
      <div className="flex items-center gap-2">
        <Button
          data-testid="paginator-prev"
          variant="outline"
          size="sm"
          disabled={atStart}
          onClick={() => onChange(Math.max(0, offset - limit))}
        >
          <ChevronLeft className="h-3.5 w-3.5" />
        </Button>
        <span data-testid="paginator-page" className="text-xs">
          {t('paginator_page', { page, totalPages })}
        </span>
        <Button
          data-testid="paginator-next"
          variant="outline"
          size="sm"
          disabled={atEnd}
          onClick={() => onChange(offset + limit)}
        >
          <ChevronRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
};
